import React, { useMemo, useState, useEffect } from "react";
//MRT Imports
import MaterialReactTable from "material-react-table";
//Material-UI Imports
import { Box, Button } from "@mui/material";
// import { data } from './makeData';
import { Container } from "@material-ui/core";

import Cookies from "universal-cookie";
import { ToastContainer, toast } from "react-toastify";

import { cognito } from "../utils/aws";

// All employee API
const url =
  "https://9o3ax69w67.execute-api.ap-south-1.amazonaws.com/dev/admin/doctors";
// const url = "http://localhost:8000/api/employee/all";

const Doctors = () => {
  const notify = () =>
    toast("Unauthorized access..!", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      type: "warning",
    });

  const cookies = new Cookies();

  const [doctorsData, setDoctorsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoctorsData();
  }, [url]);

  const getDoctorsData = async () => {
    const idToken = cookies.get("idToken");
    const refreshToken = cookies.get("refreshToken");
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: idToken,
      },
    });
    if (response.status === 401) {
      cognito.refreshToken(refreshToken);
      console.log(response);
      getDoctorsData();
    } else {
      const jsonData = await response.json();
      setDoctorsData(jsonData.data);
      console.log("DOctors Data => ", jsonData.data);
      setLoading(false);
    }
  };

  const columns = useMemo(() => [
    {
      id: "employee", //id used to define `group` column
      columns: [
        {
          accessorKey: "name", //accessorFn used to join multiple data into a single cell
          id: "name", //id is still required when using accessorFn instead of accessorKey
          header: "Name",
          size: 250,
        },
        {
          accessorKey: "speciality", //accessorKey used to define `data` column. `id` gets set to accessorKey automatically
          enableClickToCopy: true,
          header: "Speciality",
          size: 200,
        },
        {
          accessorKey: "type", //accessorKey used to define `data` column. `id` gets set to accessorKey automatically
          enableClickToCopy: true,
          header: "Type",
          filterFn: "fuzzy",
          size: 200,
        },
        {
          accessorKey: "active_status",
          // filterVariant: 'range',
          header: "Active Status",
          size: 200,
          //custom conditional format and styling
          Cell: ({ cell }) => (
            <Box
              component="span"
              sx={(theme) => ({
                backgroundColor:
                  cell.getValue() == "N"
                    ? theme.palette.error.dark
                    : theme.palette.success.dark,
                borderRadius: "0.25rem",
                color: "#fff",
                maxWidth: "9ch",
                p: "0.25rem",
              })}
            >
              {cell.getValue()?.toLocaleString?.("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </Box>
          ),
        },
      ],
    },
  ]);

  return (
    <div className="mb-5">
      <ToastContainer />
      <h2 style={{ marginTop: 20, textAlign: "center" }}>Doctors</h2>
      <Container>
        <MaterialReactTable
          columns={columns}
          data={doctorsData}
          enableColumnFilterModes
          enableColumnOrdering
          enableGrouping
          enablePinning
          enableRowSelection
          initialState={{
            showColumnFilters: false,
            density: "compact",
            columnVisibility: { type: false },
          }}
          positionToolbarAlertBanner="bottom"
          state={
            doctorsData.length > 0 ? { isLoading: false } : { isLoading: true }
          }
          muiTableBodyProps={{
            sx: {
              //stripe the rows, make odd rows a darker color
              "& tr:nth-of-type(odd)": {
                backgroundColor: "#3246c41a",
              },
            },
          }}
          renderTopToolbarCustomActions={({ table }) => {
            const handleDeactivate = () => {
              table.getSelectedRowModel().flatRows.map((row) => {
                alert("deactivating " + row.getValue("name"));
              });
            };
            const handleActivate = () => {
              table.getSelectedRowModel().flatRows.map((row) => {
                alert("activating " + row.getValue("name"));
              });
            };
            return (
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <Button
                  color="error"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleDeactivate}
                  variant="contained"
                >
                  Deactivate
                </Button>
                <Button
                  color="primary"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleActivate}
                  variant="contained"
                >
                  Activate
                </Button>
              </div>
            );
          }}
        />
      </Container>
    </div>
  );
};

export default Doctors;
